import davoLogo from "@/assets/davo-logo.png"
import mainLogo from "@/assets/reassurance-logo.png"
import { MAIN_SUPPORT_EMAIL, MAIN_SUPPORT_PHONE } from "@/constants/globals"
import { UserTenant } from "@/types/user"

const DAVO_SUPPORT_EMAIL = "support@davogroup.be"
const DAVO_SUPPORT_PHONE = "+32 9 216 60 99"

const tenantLogos = new Map<string, string>([
   ["Reassurance Solutions", mainLogo],
   ["GRASP Innovations", mainLogo],
   ["Davo Group", davoLogo],
])

const tenantSupportEmails = new Map<string, string>([
   ["Reassurance Solutions", MAIN_SUPPORT_EMAIL],
   ["GRASP Innovations", MAIN_SUPPORT_EMAIL],
   ["Davo Group", DAVO_SUPPORT_EMAIL],
])

const tenantSupportPhones = new Map<string, string>([
   ["Reassurance Solutions", MAIN_SUPPORT_PHONE],
   ["GRASP Innovations", MAIN_SUPPORT_PHONE],
   ["Davo Group", DAVO_SUPPORT_PHONE],
])

export function getTenantLogo(
   tenants: UserTenant[],
   selectedTenantId: string | null
): string {
   if (tenants.length === 0) return mainLogo
   const activeTenant =
      tenants.find((t) => t.id === selectedTenantId) ?? tenants[0]
   return tenantLogos.get(activeTenant.name) ?? mainLogo
}

export function getTenantSupportEmail(
   tenants: UserTenant[],
   selectedTenantId: string | null
): string {
   if (tenants.length === 0) return MAIN_SUPPORT_EMAIL
   const activeTenant =
      tenants.find((t) => t.id === selectedTenantId) ?? tenants[0]
   return tenantSupportEmails.get(activeTenant.name) ?? MAIN_SUPPORT_EMAIL
}

export function getTenantSupportPhone(
   tenants: UserTenant[],
   selectedTenantId: string | null
): string {
   if (tenants.length === 0) return MAIN_SUPPORT_PHONE
   const activeTenant =
      tenants.find((t) => t.id === selectedTenantId) ?? tenants[0]
   return tenantSupportPhones.get(activeTenant.name) ?? MAIN_SUPPORT_PHONE
}
